import {
	patchUserRolesName,
	type UserRoleUpdateDto,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

const userMutationsResource = Resources.base.user.mutations;

export const useUpdateUserRole = (name: string) => {
	const { t } = useResource();

	return useMutation({
		mutationFn: processResponse((data: UserRoleUpdateDto) =>
			patchUserRolesName(data, name),
		),
		onError: (error) => {
			console.error(`${t(userMutationsResource.userUpdateRoleError)}:`, error);
		},
		onSuccess: () => {
			toast.success(t(userMutationsResource.userUpdateRoleSuccess));
		},
	});
};
